import { formatChemicalCompoundInTextAsHtml } from "@omnia/shared/utils/format"
import { isNumber } from "../omnia"
import { INtrReq } from "../types"

export class CroppingReqVm {

    private _userDefined: boolean

    public requirements: INtrReq
    public hasErrors: boolean
    public errorText: string


    constructor(requirements: INtrReq) {
        this.setRequirements(requirements)
    }

    protected setRequirements(r: INtrReq) {
        this.requirements = r
        this.hasErrors = r?.HasError
        this.errorText = r?.ErrorText
    }


    /** This is true if this resource has user-defined requirements */
    get userDefined() {

        const { _userDefined: ud, requirements } = this

        if (ud !== undefined) {
            return ud
        }

        if (!requirements) {
            return false
        }

        this._userDefined = hasUserDefinedRequirements(requirements)

        return this._userDefined

    }

    hasComments(): boolean {
        return this.requirements && !!this.requirements.Comments;
    }

    get comments(): string {
        if (this.requirements) {
            return this.requirements.Comments;
        }
        return null;
    }

    getFormattedComments(): string {

        let comments: string;

        if (this.requirements) {

            if (this.hasComments()) {
                comments = formatChemicalCompoundInTextAsHtml(this.requirements.Comments);
            }
        }

        return comments;
    }

    getRequiredNutrient(nutrient: string) {

        const { requirements: r } = this

        if (!r) return undefined;

        switch (nutrient) {

            case "N":
            case "SO3":
                if (r.NCalcStatus) return undefined;
                break;

            case "P2O5":
            case "K2O":
            case "MgO":
                if (r.PkCalcStatus) return undefined;
                break;

            case "Lime":
                if (r.LimeCalcStatus) return undefined;

        }

        return r["Required" + nutrient];

    }

}

function hasUserDefinedRequirements(req: INtrReq) {

    if (req) {

        const check = (key: "N" | "SO3" | "P2O5" | "K2O" | "MgO") => {
            const cr = req["CalcRequired" + key]
            return isNumber(cr) && (req["Required" + key] != cr)
        }

        return (check("N") || check("SO3") || check("P2O5") || check("K2O") || check("MgO"))

    }

    return false

}
